<template>
  <div class="comment">
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-input
          class="input"
          clearable
          v-model="keyword"
          @input="currentChange(1)"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search">
        </el-input>
        <el-select v-model="movie_id" filterable placeholder="请选择" @change="MovieChange">
          <el-option
            v-for="item in movie"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-download" @click="uploadExcel">导出</el-button>
        <el-button type="primary" @click="refresh" icon="el-icon-refresh">刷新</el-button>
      </el-form-item>
    </el-form>
    <div class="list">
      <div class="item" v-for="(item,index) in comments" :key="index">
        <div class="user">
          <div class="head-img">
            <template v-if="item.user"><img class="head-img" :src="item.user.headimg"></template>
            <template v-else><img class="head-img" :src="$store.state.default_img_url"></template>
          </div>
          <div class="text">
            <div class="name gray">
              <template v-if="item.user"><span>{{item.user.name}}</span></template>
              <template v-else><span>未知</span></template>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span>
                {{item.created_at}}
                <i class="small">({{getDay(item.created_at)}})</i>
              </span>
            </div>
            <div class="comment">
              <pre>{{item.color}} {{item.text}}</pre>
            </div>
            <div class="bottom gray">
              <span>《{{item.movie.title}}》</span>
            </div>
          </div>
          <div class="operation">
            <i class="el-icon-delete delete cursor-pointer gray" @click="deleteComment(item)"></i>
          </div>
        </div>
      </div>
      <div class="empty" v-if="noData">
        <img src="/static/images/no-comment.png">
      </div>
    </div>
    <el-pagination
      v-if="comments.length>0"
      class="page"
      background
      layout="total, sizes, prev, pager, next"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="per_page"
      :total="total"
      :current-page="page"
      @current-change="currentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>
<script>
import request from '@/utils/request'
import getDay from '@/utils/getDay'
export default {
  name: 'musicComment',
  data () {
    return {
      page: 1,
      total: 0,
      per_page: 5,
      keyword: '',
      comments: [],
      status: '',
      noData: false,
      movie: [],
      movie_id: '',
      date: []
    }
  },
  created () {
    this.getComments()
    request({
      url: 'movie'
    }).then(res => {
      this.movie = res.data.list
    }).catch(() => {})
  },
  methods: {
    MovieChange () {
      this.getComments()
    },
    dateChange () {
      this.getComments()
    },
    uploadExcel () {
      window.open(`${process.env.BASE_API}/danmu-exp?movie_id=${this.movie_id}&start_at=${this.date[0]}&end_at=${this.date[1]}`, '_blank')
    },
    getComments () {
      return new Promise((resolve, reject) => {
        let sendData = {
          page: this.page,
          per_page: this.per_page,
          status: this.status,
          key: this.keyword,
          movie_id: this.movie_id,
          start_at: this.date[0],
          end_at: this.date[1]
        }
        request({
          url: 'danmu',
          method: 'get',
          params: sendData
        }).then(res => {
          resolve()
          this.total = res.data.item_total
          this.comments = res.data.list
          if (this.comments.length === 0) {
            this.noData = true
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    refresh () {
      this.page = 1
      this.getComments().then(res => {})
    },
    currentChange (e) {
      this.page = e
      this.getComments()
    },
    handleSizeChange (e) {
      this.per_page = e
      this.page = 1
      this.getComments()
    },
    deleteComment (item) {
      this.$confirm('删除该条弹幕，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        request({
          url: 'danmu/' + item.uuid,
          method: 'delete'
        }).then(res => {
          this.currentChange(1)
        })
      }).catch(() => {})
    },
    changeline (str) {
      return str.replace(/\n/g, '<br/>')
    },
    getDay (date) {
      return getDay(date)
    }
  }
}
</script>
<style lang="less" scoped>
.input, .select {
  width: 150px;
}
.list {
  border-top: 1px solid #E4E7ED;
  .item {
    margin-top: 10px;
    border-bottom: 1px solid #EBEEF5;
    .user {
      display: flex;
      margin-bottom: 10px;
      max-width: 700px;
      position: relative;
      .head-img {
        width: 50px;
        height: 50px;
        margin-right: 10px;
        border-radius: 5px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          display: block;
        }
      }
      .text {
        width: 600px;
        font-size: 15px;
        .name {
          margin-bottom: 5px;
          .small {
            font-style: normal;
            font-size: 13px;
          }
        }
        .images {
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          .images-item {
            width: 70px;
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            margin-bottom: 10px;
          }
        }
        .tenant-reply {
          margin-top: 5px;
          border-left: 3px solid #67C23A;
          padding: 5px 10px;
          background-color: #F2F6FC;
        }
        .bottom {
          margin-top: 10px;
          font-size: 13px;
        }
        .comment pre {
          width: 100%;
          white-space:pre-wrap;
          word-wrap:break-word;
        }
      }
      .operation {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        align-items: center;
        .switch {
          transform: scale(0.8,0.8)
        }
        .delete, .reply {
          margin-left: 6px;
          font-size: 16px;
        }
      }
    }
  }
  .empty {
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 150px;
      height: auto;
    }
  }
}
.page {
  margin-top: 10px;
  margin-bottom: 10px;
}
.product-item {
  border: 1px solid #E4E7ED;
  padding: 5px;
  .product-img {
    width: 80px;
    height: 80px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      height: auto;
    }
  }
  .product-name {
    text-align: center;
    padding: 3px 0;
    font-size: 13px;
    color: #555555;
  }
}
.warning {
  color: #E6A23C;
}
.reply-content {
  width: 700px;
  h3 {
    line-height: 45px;
    text-align: center;
  }
  .btn-group {
    text-align: center;
    margin-top: 10px;
    padding: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/comment/danmu.vue